import { RepeatOneSharp } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import Helper from "../common/Helper";
import { Role } from "../helper";
import { UserDataService } from "../services";
import { BallotDashboardService } from "../services/ballotDashboard.Service";
import AppConstatnts from "./AppConstants";
import { AdminPreferencesService } from "../services/adminPref.Service";
import { UserPreferenceService } from "../services/userPref.Service";
import { isShowUnitDrawer } from "../configs/AppSettings";
import { HistoricalCombineResultServices } from "../services/historicalGroupCombine.Service";
import { PushNotifications } from "../services/PushNotifications.Service";
import { TeamPlayerServices } from "../services/teamPlayers.Service";

export const AppDataContext = React.createContext();

export const AppDataProvider = (props) => {
  var storedEventId = sessionStorage.getItem("eventid");
  var actualEventId =
    storedEventId === null
      ? AppConstatnts.DRAFTCOMBINE_EVENT_ID
      : storedEventId;
  const [user, setUser] = useState({});
  const [originalUser, setOriginalUser] = useState({});
  const [applicationUsers, setApplicationUsers] = useState([]);
  const [combineYear, setCombineYear] = useState(2026);
  const [eventId, setEventId] = useState(0);
  const [ballotVoteEventId, setBallotVoteEventId] = useState(0);
  const [selectedEvent, setSelectedEvent] = useState(actualEventId);
  const [selectedEventId, setSelectedEventId] = useState(
    `${combineYear}${selectedEvent}`
  );

  const [selectedCombineResultsTab, setSelectedCombineResultsTab] = useState(0);
  const [selectedCareerStatsTab, setSelectedCareerStatsTab] = useState(0);

  //... Unit preference states
  const [weightUnits, setWeightUnits] = useState(1);
  const [lengthUnits, setLengthUnits] = useState(4);
  const [isShowDEXABodyFat, setIsShowDEXABodyFat] = useState("false");

  //... It's common Event list data holder for selected Event Year.
  const [commonEventList, setCommonEventList] = useState([]);

  let accessToken = sessionStorage.getItem("accessToken");

  //GET DEFAULT VISIBILITY SETTINGS
  useEffect(() => {
    if (user && accessToken) {
      getDEXABodyFatVistibilityFlag();
    }
  }, [user, accessToken]);

  useEffect(() => {
    // Store the commonEventList in localStorage
    localStorage.setItem("commonEventList", JSON.stringify(commonEventList));
  }, [commonEventList]);

  const loadContext = async () => {
    try {
      const loggedInUserEmail = UserDataService.getUserEmail(); //reading email from jwt token
      if (loggedInUserEmail) {
        const result = await UserDataService.getUserPermissionDetails(
          loggedInUserEmail
        );
        setLoggedInUserDetails(result);
      }
    } catch (error) {
      console.error(error);
    }
    getAllData();
    // getActiveEventId();
    //getActiveBallotVoteEventId();
  };

  useEffect(() => {
    if (accessToken) {
      loadContext();
    }
  }, [accessToken]);

  useEffect(() => {
    if (selectedEvent !== "")
      setSelectedEventId(`${combineYear}${selectedEvent}`);
  }, [combineYear, selectedEvent]);

  const getActiveEventId = () => {
    UserDataService.getActiveEventId().then((activeEventId) => {
      setEventId(activeEventId);
    });
  };

  useEffect(() => {
    if (user && !isShowUnitDrawer && user.userID) {
      getUserUnitPreferencesByUserID(user.userID);
    }
  }, [user]);

  // useEffect(() => {
  //   AdminPreferencesService.getCombineYears().then((response) => {
  //     let combineYearData=0;
  //     console.log("setCombineYearDropdownData ", response.data);
  //      response.data.map((item,index)=>{
  //       if(index===0)
  //       {
  //         combineYearData=parseInt(item.eventYear);
  //       }

  //     })
  //     setCombineYear(combineYearData);

  //     // response.data.forEach((item) => {
  //     //   // combineYearData.push(item);
  //     //   combineYearData.push(item.eventYear);
  //     // });
  //     // setCombineYearDropdownData(combineYearData);
  //   });
  // }, [accessToken]);

  const getActiveBallotVoteEventId = () => {
    BallotDashboardService.getActiveBallotVoteEventId().then(
      (activeBallotVoteEventId) => {
        setBallotVoteEventId(activeBallotVoteEventId);
      }
    );
  };

  const getAllData = () => {
    UserDataService.getAllApplicationUsers().then((users) => {
      let allusers = users.map((user) => {
        if (!user.role) user.role = user.userTeamLeague;

        user.appRoles = !user.appRoles ? [] : [user.appRoles];
        user.userTeamLeague = !user.userTeamLeague ? [] : [user.userTeamLeague];

        user.isAdmin = user.appRoles.includes(Role.Admin);
        return user;
      });
      setApplicationUsers(allusers);
    });
  };

  const setUserPersonate = async (user) => {
    let userApprolesData1 = user.appRoles[0].split(";");
    const currentUser = {
      userID: user.userId,
      userName: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      teamID: user.teamID,
      appRoles: user.appRoles ? userApprolesData1 : [],
      userTeamLeague: user.userTeamLeague ? [user.userTeamLeague] : [],

      signoutURL: "",
      isAdmin: user.appRoles === Role.Admin,
      playerProfileFlag: true,
      combineResultsFlag: true,
      teamBallotDashboardFlag: false,
      loginID: user.loginID, // Need loginID for userBy parameter for Admin role
    };

    if (currentUser.isAdmin) {
      currentUser.playerProfileFlag = true;
      currentUser.combineResultsFlag = true;
      currentUser.teamBallotDashboardFlag = false;
    } else {
      const playerProfileFlag = await getPlayerProfileFlag();
      currentUser.playerProfileFlag =
        playerProfileFlag[0].childName === "true" ? true : false;

      const combineResultsFlag = await getCombineResultsFlag();
      currentUser.combineResultsFlag =
        combineResultsFlag[0].childName === "true" ? true : false;

      let userAppRolesDataArr = [];
      let userApprolesData = currentUser.appRoles[0].split(";");

      for (var i = 0; i < userApprolesData.length; ++i) {
        userAppRolesDataArr.push(userApprolesData[i] + "");
      }

      // if (user.appRoles.includes(Role.CombineBallotUser)) {
      if (userAppRolesDataArr.includes(Role.CombineBallotUser)) {
        const teamBallotDashboardFlag = await getTeamBallotDashboardFlag();
        currentUser.teamBallotDashboardFlag =
          teamBallotDashboardFlag[0].childName === "true" ? true : false;
      }
    }
    sessionStorage.setItem("currentUser", JSON.stringify(currentUser));

    setUser(currentUser);
  };

  const endUserPersonate = () => {
    sessionStorage.setItem("currentUser", JSON.stringify(originalUser));
    setUser({ ...originalUser });
  };

  const getPlayerProfileFlag = async () => {
    const response = await UserDataService.getPlayerProfileDisplayFlag();
    return response;
  };

  const getCombineResultsFlag = async () => {
    const response = await UserDataService.getCombineResultsDisplayFlag();
    return response;
  };

  const getTeamBallotDashboardFlag = async () => {
    const response =
      await BallotDashboardService.getTeamBallotDashboardFlagForTeamUser();
    return response;
  };

  /**
   * This function used to get computed value based of unit filter/preferences for weight.
   * ! Note:This function only going to compute result for BAL Event.
   * ! Rest cases/events it will return default value.
   * @param {*} val
   * @returns computed value for weight Unit
   */
  function getWeightUnitValue(val) {
    if (selectedEvent !== "11") {
      return val; //! Returns default value if current Event is not BAL.
    }

    let result = 0;
    if (val !== null) {
      if (weightUnits === 3) {
        result = (val / 0.0022046).toFixed(2);
      } else if (weightUnits === 2) {
        result = (val / 2.2046).toFixed(2);
      } else {
        result = val; // return same value in case - lbs
      }
      return result;
    } else return result;
  }

  /**
   * This function used to get computed value based of unit filter/preferences for length.
   * ! Note:This function only going to compute result for BAL Event.
   * ! Rest cases/events it will return default value.
   * @param {*} valFeet
   * @param {*} valInches
   * @returns it will returns computed value for Length Unit
   */
  function getLengthUnitValue(valFeet, valInches) {
    if (selectedEvent !== "11") {
      return `${valFeet}'${" "}${valInches}"`; //! Returns default value if current Event is not BAL.
    }

    let result = "";
    if (valFeet !== null && valInches !== null) {
      if (lengthUnits === 5) {
        result = valFeet * 12 + valInches;
      } else if (lengthUnits === 7) {
        result = (valFeet * 30.48 + valInches * 2.54).toFixed(2);
      } else if (lengthUnits === 6) {
        result = (valFeet * 0.3048 + valInches * 0.0254).toFixed(2);
      } else result = `${valFeet}'${" "}${valInches}"`;
      return result;
    } else return result;
  }

  /**
   * This function used to get computed value based of unit filter/preferences for dimensions.
   * ! Note:This function only going to compute result for BAL Event.
   * ! Rest cases/events it will return default value.
   * @param {*} val
   * @returns it will returns computed value for dimension.
   */
  function getHandDimensionsUnitValue(val) {
    if (selectedEvent !== "11") {
      return val; //! Returns default value if current Event is not BAL.
    }

    let result = "";
    if (val !== null) {
      if (lengthUnits === 7) {
        result = (val * 2.54).toFixed(2);
      } else if (lengthUnits === 6) {
        result = (val * 0.0254).toFixed(2);
      } else result = val;
      return result;
    } else return result;
  }

  /**
   * This function is used to get label based on unit filter/preferences.
   * ! Note:This function only going to compute result for BAL Event.
   * @param {*} type
   * @returns dimension Label
   */
  function getHandDimensionsUnitLabelType(type) {
    if (selectedEvent !== "11") {
      return '(in")'; //! Returns default value if current Event is not BAL.
    }

    if (type !== null) {
      switch (type) {
        case 7:
          return "(cm)";
        case 6:
          return "(m)";
        default:
          return '(in")';
      }
    }
  }

  /**
   * This function is used to get label based on unit filter/preferences.
   * @param {*} type
   * ! Note:This function only going to compute result for BAL Event.
   * @returns length label
   */
  function getLengthUnitLabelType(type) {
    if (selectedEvent !== "11") {
      return "(ft' in\")"; //! Returns default value if current Event is not BAL.
    }

    if (type !== null) {
      switch (type) {
        case 4:
          return "(ft' in\")";
        case 5:
          return '(in")';
        case 6:
          return "(m)";
        case 7:
          return "(cm)";
        default:
          return "(ft' in\")";
      }
    }
  }

  /**
   * This function is used to get label based on unit filter/preferences.
   * ! Note:This function only going to compute result for BAL Event.
   * @param {*} type
   * @returns weight Label
   */
  function getWeightUnitLabelType(type) {
    //Note:This function only going to compute result for BAL Event.
    //Rest cases/events it will return default value.
    if (selectedEvent !== "11") {
      return "(lbs)"; //! Returns default value if current Event is not BAL.
    }

    if (type !== null) {
      switch (type) {
        case 3:
          return "(g)";
        case 2:
          return "(kg)";
        default:
          return "(lbs)";
      }
    }
  }

  async function getUserUnitPreferencesByUserID(iUserId) {
    UserPreferenceService.getUserUnitPreference(iUserId)
      .then((res) => {
        if (res) {
          setLengthUnits(res?.data?.length);
          setWeightUnits(res?.data?.weight);
        }
      })
      .catch((error) => console.log("getUserUnitPreferences", error));
  }

  const getDEXABodyFatVistibilityFlag = () => {
    HistoricalCombineResultServices.getDEXABodyFatDisplayFlag().then(
      (response) => {
        const childName = response?.data?.[0]?.childName;
        setIsShowDEXABodyFat(childName);
      }
    );
  };

  async function getPushNotificationReloadTime() {
    const response =
      await PushNotifications.getPushNotificationReloadTimeStamp();
    return response;
  }

  async function isDisplayTeamRoster() {
    const response = await TeamPlayerServices.isDisplayTeamRosterByEnum();
    return response;
  }

  const setLoggedInUserDetails = async (result) => {
    let userAppRolesDataArr = result.appRoles ? result.appRoles.split(";") : [];

    const currentUser = {
      userID: result.userId,
      userName: result.email,
      firstName: result.firstName,
      lastName: result.lastName,
      teamID: result.teamID,
      appRoles: userAppRolesDataArr,
      userTeamLeague: result.userTeamLeague ? [result.userTeamLeague] : [],
      signoutURL: "",
      isAdmin: result.appRoles === Role.Admin,
      playerProfileFlag: true,
      combineResultsFlag: true,
      teamBallotDashboardFlag: false,
      isCompleteTeamUser:
        userAppRolesDataArr?.some(
          (role) => !["Admin", "League"].includes(role)
        ) || false,
      loginID: result.loginID, // Need loginID for userBy parameter for Admin role
    };

    if (!currentUser.isAdmin) {
      try {
        const playerProfileFlag = await getPlayerProfileFlag();
        currentUser.playerProfileFlag =
          playerProfileFlag[0].childName === "true";

        const combineResultsFlag = await getCombineResultsFlag();
        currentUser.combineResultsFlag =
          combineResultsFlag[0].childName === "true";

        if (currentUser.appRoles.includes(Role.CombineBallotUser)) {
          const teamBallotDashboardFlag = await getTeamBallotDashboardFlag();
          currentUser.teamBallotDashboardFlag =
            teamBallotDashboardFlag[0].childName === "true";
        }
      } catch (error) {
        console.error("Error occurred while fetching user flags:", error);
      }
    }

    //...Set Push Notification time interval & roster flag globaly
    const [pushNotificationRes, teamRosterRes] = await Promise.all([
      getPushNotificationReloadTime(),
      isDisplayTeamRoster(),
    ]);

    const pushNotificationTimeStamp = pushNotificationRes?.data?.[0]?.childName;
    const isDisplayTeamRosterValue = teamRosterRes?.data?.[0]?.childName;

    if (pushNotificationTimeStamp) {
      currentUser.pushNotificationTimeStamp = +pushNotificationTimeStamp;
    }

    currentUser.isDisplayTeamRosterFlag = !!isDisplayTeamRosterValue;

    sessionStorage.setItem("currentUser", JSON.stringify(currentUser));
    setUser(currentUser);
    setOriginalUser(currentUser);
  };

  const providerValue = {
    user,
    applicationUsers,
    originalUser,
    setUser,
    setUserPersonate,
    endUserPersonate,
    getActiveEventId,
    combineYear,
    setCombineYear,
    eventId,
    ballotVoteEventId,
    loadContext,
    selectedEvent,
    setSelectedEvent,
    selectedEventId,
    setSelectedEventId,
    selectedCombineResultsTab,
    setSelectedCombineResultsTab,
    selectedCareerStatsTab,
    setSelectedCareerStatsTab,
    lengthUnits,
    weightUnits,
    setLengthUnits,
    setWeightUnits,
    getWeightUnitValue,
    getLengthUnitValue,
    getHandDimensionsUnitValue,
    getHandDimensionsUnitLabelType,
    getLengthUnitLabelType,
    getWeightUnitLabelType,
    getUserUnitPreferencesByUserID,
    isShowDEXABodyFat,
    commonEventList,
    setCommonEventList,
    setLoggedInUserDetails,
  };

  return (
    <AppDataContext.Provider value={providerValue}>
      {props.children}
    </AppDataContext.Provider>
  );
};

export const AppDataConsumer = AppDataContext.Consumer;

export default AppDataContext;
